<template>
  <div class="wrapper">
    <a class="closeBar" @click.prevent.stop="hideOutro" href="#"></a>
    <SignupContent v-show="outroType === 'signup'" :isMobile="isMobile" />
    <ShareContent v-show="outroType !== 'signup'" :isMobile="isMobile" :showOutro="showOutro" :districtIds="districtIds" :firstYear="firstYear" />
  </div>
</template>

<script>
  import ShareContent from './ShareContent';
  import SignupContent from './SignupContent';

  export default {
    name: 'Outro',
    components: {
      ShareContent,
      SignupContent
    },
    props: ['isMobile', 'showOutro', 'hideOutro', 'outroType', 'districtIds', 'firstYear'],
    computed: {
    }
  }
</script>

<style lang="scss" scoped>
.closeBar {
  position: absolute;
  top: 0;
  right: 0;
  height: 45px;
  width: 45px;
  text-decoration: none;
  &::after {
    content: '+';
    position: absolute;
    top: 0;
    right: 10px;
    transform: rotate(45deg);
    font-size: 32px;
    color: #fff;
  }
}
/* Mobile view (<900px wide) */
.mq-mobile {
  .wrapper {
    padding-top: 3em;
  }
  .closeBar {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Outro.vue